import EnglishText from "./constants/EnglishText";
import HindiText from "./constants/HindiText";
import BengaliText from "./constants/BengaliText";

export const TextMapping = {
    ENGLISH:EnglishText,
    HINDI:HindiText,
    BENGALI:BengaliText
}